<script lang="ts">
  import { UPGRADES, type UpgradeDef } from '../core/balance';
  import { purchaseStatus } from '../core/engine';
  import { sound } from '../shared/lib/audio';
  import { fmt } from '../shared/lib/format';
  import { game } from '../shared/lib/game.svelte';
  import { reveal } from './reveal.svelte';

  const shown = $derived(UPGRADES.filter((u) => reveal.upgrades.includes(u.id)));
  const hidden = $derived(UPGRADES.length - shown.length);

  function buy(u: UpgradeDef) {
    sound.unlock();
    const level = game.buy(u.id);
    if (level === null) return;
    sound.purchase();
    reveal.say(`${u.name.toLowerCase()}: ${u.effect(level).toLowerCase()}.`);
  }
</script>

<ul class="shop">
  {#each shown as u (u.id)}
    {@const level = game.s.upgrades[u.id]}
    {@const st = purchaseStatus(game.s, u.id)}
    <li>
      <div class="txt">
        <strong>
          {u.name}
          {#if u.costs.length > 1 && level > 0}<span class="lv num">{level}</span>{/if}
        </strong>
        <span>{st.kind === 'maxed' ? u.effect(level) : u.effect(level + 1)}</span>
      </div>
      {#if st.kind === 'maxed'}
        <span class="owned">owned</span>
      {:else if st.kind === 'locked'}
        <span class="owned">needs {st.needs}</span>
      {:else}
        <button
          class="cost num"
          class:ready={st.affordable}
          disabled={!st.affordable}
          onclick={() => buy(u)}
        >
          {fmt(st.cost)}
        </button>
      {/if}
    </li>
  {/each}
</ul>
{#if hidden > 0}
  <p class="more">
    {hidden === 1 ? 'Something else' : `${hidden} more things`} will turn up as you go.
  </p>
{/if}

<style>
  .shop {
    list-style: none;
    margin: 0;
    padding: 0 20px;
  }
  li {
    display: flex;
    align-items: center;
    gap: var(--space-4);
    padding: 14px 0;
    border-bottom: 1px solid var(--line);
    animation: arrive 600ms var(--ease-out) backwards;
  }
  @keyframes arrive {
    from {
      opacity: 0;
      transform: translateY(6px);
    }
  }
  .txt {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }
  .txt strong {
    font-weight: 650;
    display: inline-flex;
    gap: 6px;
    align-items: baseline;
  }
  .lv {
    font-size: var(--text-xs);
    color: var(--ink-3);
  }
  .txt span {
    font-size: var(--text-sm);
    color: var(--ink-2);
  }
  .cost {
    min-width: 72px;
    min-height: 40px;
    padding: 0 14px;
    border-radius: 999px;
    border: 1px solid var(--line);
    font-weight: 700;
    color: var(--ink-3);
    transition:
      background-color var(--t) var(--ease-out),
      color var(--t) var(--ease-out),
      transform var(--t-fast) var(--ease-out);
  }
  .cost.ready {
    background: var(--accent);
    border-color: var(--accent);
    color: var(--on-accent);
  }
  .cost.ready:active {
    transform: scale(0.96);
  }
  .owned {
    font-size: var(--text-sm);
    color: var(--ink-3);
  }
  .more {
    padding: 16px 20px 28px;
    font-size: var(--text-sm);
    color: var(--ink-3);
  }
</style>
